// extracted by css-extract-rspack-plugin
export default {"row":"row-w6aknq"};